<script>
  import { getContext } from 'svelte'
  import { getId, addSubElement, getLayoutComponent } from './builder.js'

  export let value = null
  export let id = getId()
  export let disabled = false

  export let label = value || ''
  export let info = null

  const element = getContext('currentElement')

  const change = () => element.setValue(value)

  let checked = false
  $: checked = $element.value === value

  const elementName = 'RadioGroupItem'
  addSubElement({ label, info, disabled })
</script>

<svelte:component this={getLayoutComponent(elementName)} let:inputClass {elementName} {id}>
  <input
    type="radio"
    on:change={change}
    on:change={element.onEvent}
    {checked}
    {id}
    name={$element.name}
    {value}
    {disabled}
    class={inputClass}
    aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
  />
</svelte:component>
